import { FacebookIcon, InstagramIcon, LinkedinIcon } from '@synergy/theme-next';
import { FormattedMessage } from 'react-intl';
import { PoolIconButton, useIsMobile } from '@synergy/components-next';
import { ReactElement } from 'react';
import { SocialLinks } from '@synergy/models';
import { Stack, styled } from '@mui/material';

import { FooterColumn } from './footer-column';
import { FooterColumnTitle } from './footer-column-title';
import { FooterLink } from '../../../models/footer-link';

const StyledFooterColumn = styled(FooterColumn)(({ theme }) => ({
    [theme.breakpoints.up('sm')]: {
        marginBottom: theme.spacing(1.5),
        width: 116,
    },
}));

const Wrapper = styled(Stack)(({ theme }) => ({
    flexDirection: 'row',
    gap: theme.spacing(1.5),

    [theme.breakpoints.down('sm')]: {
        justifyContent: 'center',
        gap: theme.spacing(3),
        marginTop: theme.spacing(2),
    },
}));

const StyledIconButton = styled(PoolIconButton)(({ theme }) => ({
    padding: 0,
    minHeight: 32,
    minWidth: 32,
    color: theme.palette.grey[500],

    '&:hover': {
        color: theme.palette.common.white,
    },
}));

export const SocialMedia = ({ links }: { links: FooterLink[] }): ReactElement => {
    const isMobile = useIsMobile();

    const getIcon = (link: FooterLink): ReactElement => {
        switch (link.icon) {
            case SocialLinks.Instagram:
                return <InstagramIcon fontSize="large" />;
            case SocialLinks.Facebook:
                return <FacebookIcon fontSize="large" />;
            case SocialLinks.LinkedIn:
                return <LinkedinIcon fontSize="large" />;
            default:
                return <span>{link.title}</span>;
        }
    };

    return (
        <StyledFooterColumn>
            <FooterColumnTitle sx={{ textAlign: isMobile ? 'center' : 'end' }}>
                <FormattedMessage id="app.footer.socialMedia.headline" />
            </FooterColumnTitle>
            <li>
                <Wrapper sx={{ justifyContent: isMobile ? 'center' : 'end' }}>
                    {links.map((link, index) => (
                        <StyledIconButton
                            id={link.elementId}
                            key={index}
                            onClick={() => window.open(link.url, '_blank')}
                        >
                            {getIcon(link)}
                        </StyledIconButton>
                    ))}
                </Wrapper>
            </li>
        </StyledFooterColumn>
    );
};
